module.exports = __webpack_public_path__ + "img/poslovi.edcea9a8.png";